"use strict";exports.__esModule = true;var MAX_CHUNK_SIZE = exports.MAX_CHUNK_SIZE = 99 * 1024 * 1024; // 99Mb
var MAX_VIDEO_SIZE = exports.MAX_VIDEO_SIZE = 500 * 1024 * 1024; // 500Mb
var MAX_IMAGE_SIZE = exports.MAX_IMAGE_SIZE = 30 * 1024 * 1024; // 30Mb

var calcChunks = function calcChunks(size) {
  var chunks = [0];
  var idx = 1;
  var rest = size;

  var calc = function calc(chunk) {
    if (chunk > MAX_CHUNK_SIZE) {
      chunks.push(MAX_CHUNK_SIZE * idx);
      rest -= MAX_CHUNK_SIZE;
      idx += 1;
      calc(rest);
    } else {
      chunks.push(size);
    }
  };

  calc(rest);

  return chunks;
};

var splitFileToChunks = exports.splitFileToChunks = function splitFileToChunks(file) {
  var totalSize = file.size;
  var chunks = calcChunks(totalSize);

  return chunks.reduce(function (acc, item, idx) {
    var offset = idx * MAX_CHUNK_SIZE;
    var chunkData = file.slice(offset, offset + MAX_CHUNK_SIZE);
    var from = acc[idx - 1] ? acc[idx - 1].to + 1 : 0;
    var to = from + chunkData.size - 1;

    var headerValue = "bytes " + from + "-" + to + "/" + totalSize;

    var data = {
      chunkData: chunkData,
      rangeHeaderValue: headerValue,
      to: to,
      from: from };


    if (chunkData.size) {
      acc.push(data);
    }

    return acc;
  }, []);
};


//////////////////
// WEBPACK FOOTER
// ./src/components/UploadAssetWidget/helpers.js
// module id = 2877
// module chunks = 0